"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AddressType_Factory = /** @class */ (function () {
    function AddressType_Factory() {
    }
    AddressType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AddressType1: model.AddressType1,
            AddressTypeCode: model.AddressTypeCode,
        };
        return result;
    };
    AddressType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AddressType1: model.AddressType1,
            AddressTypeCode: model.AddressTypeCode,
        };
        return result;
    };
    return AddressType_Factory;
}());
exports.AddressType_Factory = AddressType_Factory;
